import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const assetSelector = ({ asset }: ReducerState) => asset;
export const assetLoadingSelector = createSelector(
  assetSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
